module.exports = __webpack_public_path__ + "media/images/stories-share-99db1dd53dbb7710aa78cb64dd02d55f.jpg";